<template>
  <div class="loginPage">
    <div class="loginColumn">
      <img class="loginLogo" src="@/assets/searchLogo.svg" />
      <img class="loginImage" src="@/assets/loginIcon.png" />
      <img class="loginLogoText" src="@/assets/CourseLnk.png" />
    </div>
    <div class="loginColumn">
      <div class="loginForm">
        <div v-if="!isVerification" class="password">
          <p class="loginTitle">Password Reset Email Sent</p>
          <div class="centerImage">
            <img class="sentEmailIcons" src="@/assets/newPasswordIcon.png" />
          </div>
          <p class="emailText">
            An email has been sent to your university email with instructions on
            how to reset your password
          </p>
          <div class="loginSignupDivider"></div>
          <div class="signupBox">
            <router-link
              class="joinButtonSmall toSignup"
              :to="{ name: 'SetUp' }"
              >Continue</router-link
            >
          </div>
        </div>

        <div v-else class="verification">
          <p class="loginTitle">Verification Email Sent</p>
          <div class="centerImage">
            <img
              class="sentEmailIcons"
              src="@/assets/verificationEmailIcon.png"
            />
          </div>
          <p class="emailText">
            A verification email has been sent to your school email.
          </p>
          <p class="emailText">
            Please verify your email to continue the sign up process
          </p>
          <div class="loginSignupDivider"></div>
          <div class="signupBox">
            <p style="color: red">{{ this.feedback }}</p>
            <button class="joinButtonSmall toSignup" @click="checkIfVerified">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomNav">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <router-link
        class="landingButton"
        :to="{
          name: 'Landingpage',
        }"
        >About</router-link
      >
      <router-link
        class="landingButton"
        :to="{ name: 'Terms' }"
        target="_blank"
      >
        Terms and Conditions
      </router-link>
      <router-link
        class="landingButton"
        :to="{ name: 'Privacy' }"
        target="_blank"
      >
        Privacy Policy
      </router-link>
      <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
        Join the team
      </router-link>
    </div>
    <div class="bottomNavSmall">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{
            name: 'Landingpage',
          }"
          >About</router-link
        >
        <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
          Join the team
        </router-link>
      </div>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{ name: 'Terms' }"
          target="_blank"
        >
          Terms and Conditions
        </router-link>
        <router-link
          class="landingButton"
          :to="{ name: 'Privacy' }"
          target="_blank"
        >
          Privacy Policy
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
export default {
  props: ["isVerification"],

  data: () => ({
    feedback: "",
  }),

  methods: {
    checkIfVerified() {
      firebase
        .auth()
        .currentUser.reload()
        .then(() => {
          console.log(firebase.auth().currentUser.emailVerified, "currents");

          if (firebase.auth().currentUser.emailVerified) {
            this.$router.push({ name: "SetUp" });
          } else {
            this.feedback = "You must verify your email";
          }
        });
    },
  },
};
</script>

<style scoped src="@/styles/components/auth/Login.css"></style>
